import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  from: '',
  email: '',
  phoneNumber: '',
  cars: [  
    { id: 1, receiving: '', numberFBA: '', quantity: 0, palletsNumber: 0 },
    { id: 2, receiving: '', numberFBA: '', quantity: 0, palletsNumber: 0 }
  ],
  sealNumber: '',
  sealNumber2: '',
  firstDate: '',
  secondDate: '',
  type: '',
  trailerType: '',
  trailerPlates: '',
  swapbodyPlates: '',
  swapbodyPlates2: '',
  user: {},
  accountType: 'Manager',
  unavailableTimeslotDate: [],
  preAlert: {},
  preAlerts: [],
  preAlertID: '',
  title: 'Add new pre-alert',
  randomTime: [],
};

export const counterSlice = createSlice({
  name: 'counter',
  initialState,
  reducers: {
    carsAdded(state, action) {
      const { id, ...updates } = action.payload;
      return {
        ...state,
        cars: state.cars.map(car =>
          car.id === id ? { ...car, ...updates } : car
        )
      }
    },
    fieldUpdate(state, action) {
      const { fieldName, value } = action.payload;
      return {
        ...state,
        [fieldName]: value
      };
    },
    updateDates(state, action) {
      const { date, value } = action.payload;
      return {
        ...state,
        [date]: value 
      };
    },
    removeFirstDate(state){
      state.firstDate = '';
    },
    removeSecondDate(state){
      state.secondDate = '';
    },
    updateUser(state, action) {
      state.user = action.payload;
    },
    updateAccountType(state, action) {
      state.accountType = action.payload;
    },
    updateUnavailableTimeslotDate(state, action) {
      state.unavailableTimeslotDate = action.payload;
    },
    updatePreAlert(state, action) {
      state.preAlert = action.payload;
    },
    updateTitle(state, action) {
      state.title = action.payload;
    },
    updatePreAlerts(state, action) { // Dodaj nowy reducer dla ustawiania pre-alerts
      state.preAlerts = action.payload;
    },
    updatePreAlertID(state, action) { // Dodaj nowy reducer dla ustawiania pre-alerts
      state.preAlertID = action.payload;
    },
    addCar(state) {
      const newCar = {
        id: state.cars.length + 1, // Nowy identyfikator będzie o 1 większy niż ostatni identyfikator
        receiving: '',
        numberFBA: '',
        quantity: 0,
        palletsNumber: 0,
      };
      return {
        ...state,
        cars: [...state.cars, newCar] // Dodaj nowy obiekt do tablicy `cars`
      };
    },
    generateRandomTime(state) {
      const startHour = 8;
      const endHour = 16;

      const randomHour =
        Math.floor(Math.random() * (endHour - startHour)) + startHour;
      const randomMinute = Math.random() < 0.5 ? 0 : 30; // Minuty to albo 0 albo 30

      return {
        ...state,
        randomTime: [...state.randomTime, { hour: randomHour, minute: randomMinute }] // Dodaj nowy obiekt do tablicy `cars`
      };
    }
  }
});

// Action creators are generated for each case reducer function
export const { carsAdded, fieldUpdate, updateDates, removeDateConditionally, removeSecondDate, removeFirstDate, updateUser, updateAccountType, updateUnavailableTimeslotDate, updatePreAlert, updateTitle, updatePreAlerts, updatePreAlertID, addCar, generateRandomTime } = counterSlice.actions;

export default counterSlice.reducer;